export enum NapiCookieLabels {
  CODE_CHALLENGE = 'codeChallenge',
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
  ACCESS_TOKEN_EXPIRATION = 'accessTokenExpiration',
}
